export default {
  name: {
    required: () => 'Укажите имя',
    max:(n,e) => "Имя должно быть короче "+e[0]+" символов"
  },
  contacts: {
    required: () => 'Укажите E-Mail или Skype',
    max:(n,e) => "E-Mail или Skype должны быть короче "+e[0]+" символов"
  },
  message: {
    required: () => 'Напишите сообщение',
    max:(n,e) => "Сообщение должно быть короче "+e[0]+" символов"
  }
}



// WEBPACK FOOTER //
// ./src/strings/validator/custom/ru.js